import classnames from 'classnames'

import { StockDetailTimeframeBar } from '../../../app/charts-lib'
import { Button } from '../../../main/components/button'
import { NotificationWrapper } from '../../../main/components/notification'
import { decodeQueryString } from '../../queryString'
import { ChartTypesSelect } from '../chart-type-select'

interface Props {
  index: number
  isInteractiveChart: boolean
  isStockDetailUpdating: boolean
}

const hasRedesign = FinvizSettings.hasRedesignEnabled

export function QuoteMenu({ index, isInteractiveChart, isStockDetailUpdating }: Props) {
  const { t, ty, p } = decodeQueryString()
  const urlTickers = t.split(',')
  const isPremium = FinvizSettings.hasUserPremium

  return (
    <div
      className={classnames('mb-1 flex items-center p-1.5 py-0.5 font-sans', {
        'border-b border-[#f3f3f3]': !FinvizSettings.hasRedesignEnabled,
      })}
    >
      <div className="w-full" />
      {ty !== 'p' && ty !== 'oc' && (
        <>
          <div className="ml-auto mr-0.5 items-center">
            <ChartTypesSelect isPremium={isPremium} />
          </div>
          <div className="ml-0.5 w-[26.75rem] shrink-0 overflow-hidden">
            <NotificationWrapper>
              <StockDetailTimeframeBar
                size="medium"
                isPremium={isPremium}
                isDateRangeAvailable={isInteractiveChart}
                isLoadingOverride={isInteractiveChart ? undefined : isStockDetailUpdating}
                isScrollIntoViewEnabled
              />
            </NotificationWrapper>
          </div>
        </>
      )}
      <div className="flex w-full justify-end">
        {ty !== 'p' && ty !== 'oc' ? (
          <Button
            rounding={hasRedesign ? undefined : 'none'}
            leftContent="share"
            size="medium"
            className="js-publish-chart"
            data-testid="chart-toolbar-publish"
            data-index={index}
            data-ticker={urlTickers[index]}
            data-timeframe={p}
          >
            Share
          </Button>
        ) : null}
      </div>
    </div>
  )
}
